import { UrlSegment, UrlMatchResult } from '@angular/router';

export function TgWebAppStartParamMatcher(key: string) {
    return function (urls: UrlSegment[]) {
        const queryParams = new URLSearchParams((window.location as any).search);
        const startApp = queryParams.get('tgWebAppStartParam');
        if (startApp && (startApp.toLocaleLowerCase() === key.toLocaleLowerCase())) {
            return ({
                consumed: urls,
            }) as UrlMatchResult;
        }
        return null;
    }
};

export function MainMatcher(urls: UrlSegment[]) {
    if (urls.length > 1 && urls[0].path === 'wait' || !urls.length) {
        return null;
    }
    if (urls.length === 1 && (urls[0].path === 'live' || urls[0].path === 'soon' || urls[0].path === 'wait')) {
        return ({
            consumed: urls,
            posParams: {
                'tab': urls[0],
            },
        }) as UrlMatchResult;
    } else if (urls.length && (urls[0].path === 'live' || urls[0].path === 'soon')) {
        if (urls.length === 2) {
            return ({
                consumed: urls,
                posParams: {
                    'tab': urls[0],
                    'sport_id': urls[1],

                },
            }) as UrlMatchResult;
        } else if (urls.length === 3) {
            return ({
                consumed: urls,
                posParams: {
                    'tab': urls[0],
                    'sport_id': urls[1],
                    'tournament_id': urls[2],
                },
            }) as UrlMatchResult;
        }
    }
    return null;
}

export function StreamMatcher(urls: UrlSegment[]) {

    if (urls.length === 4 && urls[0].path === 'watch') {
        return ({
            consumed: urls,
            posParams: {
                'id': urls[3],
                'sport_id': urls[1],
                'tournament_id': urls[2],
            },
        }) as UrlMatchResult;
    }
    return null;
}

export function BookmakersMatcher(urls: UrlSegment[]) {
    if (urls.length > 0 && urls[0].path === 'bookmakers') {
        let p = urls.length === 2?{cc:urls[1]}:{}
        return ({
            consumed: urls,
            posParams: p
        }) as UrlMatchResult;
    }
    return null;
}



